import {useMutation} from '@apollo/react-hooks';

import type {
    FormCreateRulesUpdate as FormCreateRulesUpdateMutation,
    FormCreateRulesUpdateVariables as FormCreateRulesUpdateMutationVariables,
    FormCreateRulesUpdateInput,
} from 'nutshell-graphql-types';

import FORM_FRAGMENT from '../../graphql/fragments/form-fragment.graphql';
import CREATE_RULES_UPDATE from '../../graphql/mutations/update-create-rules.graphql';

export function useUpdateCreateRules(): (arg1: FormCreateRulesUpdateInput) => Promise<any> {
    const [updateCreateRules] = useMutation<
        FormCreateRulesUpdateMutation,
        FormCreateRulesUpdateMutationVariables
    >(CREATE_RULES_UPDATE);

    return (input: FormCreateRulesUpdateInput) => {
        return updateCreateRules({
            variables: {input},
            update: (proxy, mutationResults) => {
                // Read the data from our cache for this fragment.
                const formFragment = proxy.readFragment({
                    id: input.form.id,
                    fragmentName: 'FormFragment',
                    fragment: FORM_FRAGMENT,
                });

                if (formFragment) {
                    const updatedForm =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.formCreateRulesUpdate &&
                        mutationResults.data.formCreateRulesUpdate.form;

                    if (!updatedForm) return;

                    proxy.writeFragment({
                        id: input.form.id,
                        fragmentName: 'FormFragment',
                        fragment: FORM_FRAGMENT,
                        data: updatedForm,
                    });
                }
            },
        });
    };
}
